// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Live training chat — Digiping shell (Digiping | Players | Teams) */

.lt-fb-sheet-portal {
  position: fixed;
  inset: 0;
  z-index: 1400;
  background: rgba(8, 12, 22, 0.72);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  box-sizing: border-box;
}

.lt-fb-sheet-portal--landscape {
  align-items: center;
  padding-top: max(8px, env(safe-area-inset-top));
  padding-bottom: max(8px, env(safe-area-inset-bottom));
}

.lt-fb-sheet.lt-fb-sheet--digiping {
  width: 100%;
  max-width: min(520px, 100%);
  max-height: min(92dvh, calc(100dvh - env(safe-area-inset-top)));
  min-height: 0;
  height: min(92dvh, calc(100dvh - env(safe-area-inset-top)));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 18px 18px 0 0;
  border: 1px solid var(--dp-border, rgba(255, 255, 255, 0.08));
  border-bottom: none;
  box-shadow: 0 -16px 48px rgba(0, 0, 0, 0.45);
  padding-bottom: var(--lt-feedback-kb-offset, 0px);
  background: var(--dp-glass, rgba(15, 23, 42, 0.96));
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  color: var(--dp-text, #f8fafc);
}

.lt-fb-sheet-portal--landscape .lt-fb-sheet.lt-fb-sheet--digiping {
  max-height: min(92dvh, calc(100dvh - 24px - env(safe-area-inset-top) - env(safe-area-inset-bottom)));
  height: min(92dvh, calc(100dvh - 24px - env(safe-area-inset-top) - env(safe-area-inset-bottom)));
  border-radius: 18px;
  border-bottom: 1px solid var(--dp-border, rgba(255, 255, 255, 0.08));
}

/* Tabs */
.dp-session-tabs {
  display: flex;
  gap: 6px;
  padding: 0.55rem 1rem 0.65rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(8, 15, 28, 0.4);
  flex-shrink: 0;
}

.dp-session-tabs__tab {
  flex: 1 1;
  border: 1px solid transparent;
  border-radius: 999px;
  padding: 0.55rem 0.75rem;
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--dp-muted, #94a3b8);
  background: rgba(255, 255, 255, 0.04);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.dp-session-tabs__tab:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

.dp-session-tabs__tab--active {
  color: #fff;
  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 45%, transparent);
  background: color-mix(in srgb, var(--dp-primary, #0877bc) 28%, transparent);
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--dp-accent, #0a8cd8) 18%, transparent);
}

.dp-session-recipient {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
  background: rgba(8, 15, 28, 0.35);
}

.dp-session-recipient__label {
  font-size: 11px;
  font-weight: 700;
  color: var(--dp-muted, #94a3b8);
  text-transform: uppercase;
  letter-spacing: 0.4px;
  white-space: nowrap;
}

.dp-session-recipient__select {
  flex: 1 1;
  min-width: 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  padding: 8px 10px;
  background: rgba(15, 23, 42, 0.9);
  color: #f8fafc;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
}

.dp-session-recipient__select:focus {
  outline: none;
  border-color: var(--brand-primary, #0877bc);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent);
}

.dp-session-pane {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dp-session-pane[hidden] {
  display: none !important;
}

.dp-session-pane--digiping {
  min-height: 0;
}

.dp-session-pane--digiping .digiping-chat--embedded,
.dp-session-pane--digiping .digiping-chat__panel--embedded {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  border: none;
  background: transparent;
  max-width: none;
}

.dp-session-history {
  gap: 0.85rem;
  padding: 1rem 1rem 0.85rem;
}

.dp-session-empty {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.65rem;
  text-align: center;
  color: var(--dp-muted, #94a3b8);
  font-size: 0.9rem;
  padding: 2rem 1rem;
  max-width: 280px;
}

.dp-session-group {
  align-self: center;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  color: var(--dp-muted, #94a3b8);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.dp-session-group--current {
  color: #e2e8f0;
  background: color-mix(in srgb, var(--dp-primary, #0877bc) 22%, transparent);
}

.dp-session-group__badge {
  color: var(--dp-accent, #0a8cd8);
}

.dp-session-msg {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  max-width: 92%;
  animation: digipingMsgIn 0.35s ease both;
}

.dp-session-msg--mine {
  align-self: flex-end;
  flex-direction: row-reverse;
}

.dp-session-msg--theirs {
  align-self: flex-start;
}

.dp-session-msg__bubble {
  min-width: 0;
  padding: 0.7rem 0.9rem;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(30, 41, 59, 0.88);
  color: #f1f5f9;
  font-size: 0.92rem;
  line-height: 1.45;
}

.dp-session-msg--mine .dp-session-msg__bubble {
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--dp-primary, #0877bc) 72%, #0f172a),
    color-mix(in srgb, var(--dp-primary-dark, #065a8f) 85%, #0b0f19)
  );
  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 35%, transparent);
}

.dp-session-msg--digiping .dp-session-msg__bubble {
  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 45%, transparent);
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--dp-primary, #0877bc) 22%, rgba(15, 23, 42, 0.95)),
    rgba(15, 23, 42, 0.96)
  );
}

.dp-session-msg__avatar--digiping {
  box-shadow: 0 0 16px color-mix(in srgb, var(--dp-accent, #0a8cd8) 28%, transparent);
}

.dp-session-msg__initial {
  font-size: 0.8rem;
  font-weight: 700;
  color: #fff;
}

.dp-session-msg__text {
  white-space: pre-wrap;
  word-break: break-word;
}

.dp-session-msg__digiping-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--dp-accent, #0a8cd8);
  margin-bottom: 0.35rem;
}

.dp-session-msg__audio,
.dp-session-msg__video {
  min-width: 180px;
  max-width: 260px;
}

.dp-session-msg__video video {
  width: 100%;
  border-radius: 10px;
  display: block;
}

.dp-session-composer {
  flex-shrink: 0;
}

.dp-session-composer .digiping-chat__composer {
  align-items: center;
}

.dp-session-composer__input {
  min-height: 44px;
  max-height: 44px;
  resize: none;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}

.dp-session-composer__actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.dp-session-composer__media {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--dp-muted, #94a3b8);
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  cursor: pointer;
  font-size: 22px;
  touch-action: manipulation;
}

.dp-session-composer__media:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

.dp-session-composer__media--disabled {
  opacity: 0.45;
  pointer-events: none;
}

.dp-session-composer__mic {
  display: flex;
  align-items: center;
}

.dp-session-composer__mic--disabled {
  opacity: 0.45;
  pointer-events: none;
}

.dp-session-composer__mic .audio-recorder {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  width: 44px !important;
  max-width: 44px !important;
  height: 44px !important;
  overflow: hidden;
}

.dp-session-composer__mic .audio-recorder.recording {
  width: auto !important;
  max-width: none !important;
  height: auto !important;
  min-height: 44px;
}

.dp-session-composer__mic .audio-recorder-mic {
  color: var(--dp-muted, #94a3b8) !important;
  padding: 14px !important;
  box-sizing: border-box !important;
  width: 44px !important;
  height: 44px !important;
}

.dp-session-composer__mic .audio-recorder-mic:hover,
.dp-session-composer__mic .audio-recorder-mic:active {
  color: var(--dp-accent, #0a8cd8) !important;
}

.dp-session-composer__mic .audio-recorder-visualizer {
  display: none !important;
}

.dp-session-uploading {
  margin: 0;
  padding: 0 12px 10px;
  font-size: 12px;
  color: var(--dp-muted, #94a3b8);
  text-align: center;
}

/* Embedded Digiping toolbar */
.digiping-chat__embedded-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.45rem 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(8, 15, 28, 0.35);
  flex-shrink: 0;
}

/* Voice hold overlay — Digiping-aligned */
.lt-fb-voice-hold-portal {
  position: fixed;
  inset: 0;
  z-index: 1450;
  background: rgba(8, 12, 22, 0.72);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 16px;
  padding-bottom: max(16px, env(safe-area-inset-bottom));
}

.lt-fb-voice-hold {
  width: min(100%, 420px);
  background: var(--dp-glass, rgba(15, 23, 42, 0.96));
  border-radius: 16px;
  border: 1px solid var(--dp-border, rgba(255, 255, 255, 0.08));
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  color: var(--dp-text, #f8fafc);
}

.lt-fb-voice-hold .fb-conv-header,
.lt-fb-voice-hold .digiping-chat__header {
  position: relative;
  padding-right: 44px;
}

.lt-fb-voice-hold__hint {
  margin: 0;
  padding: 0 14px 12px;
  font-size: 12px;
  color: var(--dp-muted, #94a3b8);
}

.lt-fb-voice-hold__composer {
  padding: 12px 14px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  justify-content: center;
}

.lt-fb-voice-hold__composer .audio-recorder {
  background: transparent !important;
  box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingFeedbackSheet.css"],"names":[],"mappings":"AAAA,qEAAqE;;AAErE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,uCAAuC;EACvC,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,+DAA+D;EAC/D,aAAa;EACb,2DAA2D;EAC3D,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,6DAA6D;EAC7D,mBAAmB;EACnB,4CAA4C;EAC5C,iDAAiD;EACjD,mDAAmD;EACnD,2BAA2B;EAC3B,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,oGAAoG;EACpG,gGAAgG;EAChG,mBAAmB;EACnB,oEAAoE;AACtE;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,6BAA6B;EAC7B,kDAAkD;EAClD,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,qCAAqC;EACrC,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,4EAA4E;EAC5E,2EAA2E;EAC3E,oFAAoF;AACtF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kDAAkD;EAClD,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,wFAAwF;AAC1F;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,oBAAoB;EACpB,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,2EAA2E;AAC7E;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;;;;GAIC;EACD,4EAA4E;AAC9E;;AAEA;EACE,4EAA4E;EAC5E;;;;GAIC;AACH;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,wBAAwB;EACxB,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;EACrB,kDAAkD;EAClD,iCAAiC;EACjC,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,sDAAsD;AACxD;;AAEA;EACE,uBAAuB;EACvB,mDAAmD;EACnD,mBAAmB;EACnB,6DAA6D;EAC7D,0CAA0C;EAC1C,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;EAC/C,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B","sourcesContent":["/* Live training chat — Digiping shell (Digiping | Players | Teams) */\n\n.lt-fb-sheet-portal {\n  position: fixed;\n  inset: 0;\n  z-index: 1400;\n  background: rgba(8, 12, 22, 0.72);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding-left: env(safe-area-inset-left);\n  padding-right: env(safe-area-inset-right);\n  box-sizing: border-box;\n}\n\n.lt-fb-sheet-portal--landscape {\n  align-items: center;\n  padding-top: max(8px, env(safe-area-inset-top));\n  padding-bottom: max(8px, env(safe-area-inset-bottom));\n}\n\n.lt-fb-sheet.lt-fb-sheet--digiping {\n  width: 100%;\n  max-width: min(520px, 100%);\n  max-height: min(92dvh, calc(100dvh - env(safe-area-inset-top)));\n  min-height: 0;\n  height: min(92dvh, calc(100dvh - env(safe-area-inset-top)));\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: 18px 18px 0 0;\n  border: 1px solid var(--dp-border, rgba(255, 255, 255, 0.08));\n  border-bottom: none;\n  box-shadow: 0 -16px 48px rgba(0, 0, 0, 0.45);\n  padding-bottom: var(--lt-feedback-kb-offset, 0px);\n  background: var(--dp-glass, rgba(15, 23, 42, 0.96));\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  color: var(--dp-text, #f8fafc);\n}\n\n.lt-fb-sheet-portal--landscape .lt-fb-sheet.lt-fb-sheet--digiping {\n  max-height: min(92dvh, calc(100dvh - 24px - env(safe-area-inset-top) - env(safe-area-inset-bottom)));\n  height: min(92dvh, calc(100dvh - 24px - env(safe-area-inset-top) - env(safe-area-inset-bottom)));\n  border-radius: 18px;\n  border-bottom: 1px solid var(--dp-border, rgba(255, 255, 255, 0.08));\n}\n\n/* Tabs */\n.dp-session-tabs {\n  display: flex;\n  gap: 6px;\n  padding: 0.55rem 1rem 0.65rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(8, 15, 28, 0.4);\n  flex-shrink: 0;\n}\n\n.dp-session-tabs__tab {\n  flex: 1;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  padding: 0.55rem 0.75rem;\n  font-family: inherit;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--dp-muted, #94a3b8);\n  background: rgba(255, 255, 255, 0.04);\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n}\n\n.dp-session-tabs__tab:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.dp-session-tabs__tab--active {\n  color: #fff;\n  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 45%, transparent);\n  background: color-mix(in srgb, var(--dp-primary, #0877bc) 28%, transparent);\n  box-shadow: 0 0 0 1px color-mix(in srgb, var(--dp-accent, #0a8cd8) 18%, transparent);\n}\n\n.dp-session-recipient {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  flex-shrink: 0;\n  background: rgba(8, 15, 28, 0.35);\n}\n\n.dp-session-recipient__label {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--dp-muted, #94a3b8);\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  white-space: nowrap;\n}\n\n.dp-session-recipient__select {\n  flex: 1;\n  min-width: 0;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 10px;\n  padding: 8px 10px;\n  background: rgba(15, 23, 42, 0.9);\n  color: #f8fafc;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n}\n\n.dp-session-recipient__select:focus {\n  outline: none;\n  border-color: var(--brand-primary, #0877bc);\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent);\n}\n\n.dp-session-pane {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.dp-session-pane[hidden] {\n  display: none !important;\n}\n\n.dp-session-pane--digiping {\n  min-height: 0;\n}\n\n.dp-session-pane--digiping .digiping-chat--embedded,\n.dp-session-pane--digiping .digiping-chat__panel--embedded {\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  border: none;\n  background: transparent;\n  max-width: none;\n}\n\n.dp-session-history {\n  gap: 0.85rem;\n  padding: 1rem 1rem 0.85rem;\n}\n\n.dp-session-empty {\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.65rem;\n  text-align: center;\n  color: var(--dp-muted, #94a3b8);\n  font-size: 0.9rem;\n  padding: 2rem 1rem;\n  max-width: 280px;\n}\n\n.dp-session-group {\n  align-self: center;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.35rem 0.75rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.06);\n  color: var(--dp-muted, #94a3b8);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.dp-session-group--current {\n  color: #e2e8f0;\n  background: color-mix(in srgb, var(--dp-primary, #0877bc) 22%, transparent);\n}\n\n.dp-session-group__badge {\n  color: var(--dp-accent, #0a8cd8);\n}\n\n.dp-session-msg {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  max-width: 92%;\n  animation: digipingMsgIn 0.35s ease both;\n}\n\n.dp-session-msg--mine {\n  align-self: flex-end;\n  flex-direction: row-reverse;\n}\n\n.dp-session-msg--theirs {\n  align-self: flex-start;\n}\n\n.dp-session-msg__bubble {\n  min-width: 0;\n  padding: 0.7rem 0.9rem;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(30, 41, 59, 0.88);\n  color: #f1f5f9;\n  font-size: 0.92rem;\n  line-height: 1.45;\n}\n\n.dp-session-msg--mine .dp-session-msg__bubble {\n  background: linear-gradient(\n    135deg,\n    color-mix(in srgb, var(--dp-primary, #0877bc) 72%, #0f172a),\n    color-mix(in srgb, var(--dp-primary-dark, #065a8f) 85%, #0b0f19)\n  );\n  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 35%, transparent);\n}\n\n.dp-session-msg--digiping .dp-session-msg__bubble {\n  border-color: color-mix(in srgb, var(--dp-accent, #0a8cd8) 45%, transparent);\n  background: linear-gradient(\n    135deg,\n    color-mix(in srgb, var(--dp-primary, #0877bc) 22%, rgba(15, 23, 42, 0.95)),\n    rgba(15, 23, 42, 0.96)\n  );\n}\n\n.dp-session-msg__avatar--digiping {\n  box-shadow: 0 0 16px color-mix(in srgb, var(--dp-accent, #0a8cd8) 28%, transparent);\n}\n\n.dp-session-msg__initial {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #fff;\n}\n\n.dp-session-msg__text {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.dp-session-msg__digiping-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--dp-accent, #0a8cd8);\n  margin-bottom: 0.35rem;\n}\n\n.dp-session-msg__audio,\n.dp-session-msg__video {\n  min-width: 180px;\n  max-width: 260px;\n}\n\n.dp-session-msg__video video {\n  width: 100%;\n  border-radius: 10px;\n  display: block;\n}\n\n.dp-session-composer {\n  flex-shrink: 0;\n}\n\n.dp-session-composer .digiping-chat__composer {\n  align-items: center;\n}\n\n.dp-session-composer__input {\n  min-height: 44px;\n  max-height: 44px;\n  resize: none;\n  padding-top: 0.7rem;\n  padding-bottom: 0.7rem;\n}\n\n.dp-session-composer__actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.dp-session-composer__media {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--dp-muted, #94a3b8);\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  cursor: pointer;\n  font-size: 22px;\n  touch-action: manipulation;\n}\n\n.dp-session-composer__media:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.dp-session-composer__media--disabled {\n  opacity: 0.45;\n  pointer-events: none;\n}\n\n.dp-session-composer__mic {\n  display: flex;\n  align-items: center;\n}\n\n.dp-session-composer__mic--disabled {\n  opacity: 0.45;\n  pointer-events: none;\n}\n\n.dp-session-composer__mic .audio-recorder {\n  background: transparent !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n  width: 44px !important;\n  max-width: 44px !important;\n  height: 44px !important;\n  overflow: hidden;\n}\n\n.dp-session-composer__mic .audio-recorder.recording {\n  width: auto !important;\n  max-width: none !important;\n  height: auto !important;\n  min-height: 44px;\n}\n\n.dp-session-composer__mic .audio-recorder-mic {\n  color: var(--dp-muted, #94a3b8) !important;\n  padding: 14px !important;\n  box-sizing: border-box !important;\n  width: 44px !important;\n  height: 44px !important;\n}\n\n.dp-session-composer__mic .audio-recorder-mic:hover,\n.dp-session-composer__mic .audio-recorder-mic:active {\n  color: var(--dp-accent, #0a8cd8) !important;\n}\n\n.dp-session-composer__mic .audio-recorder-visualizer {\n  display: none !important;\n}\n\n.dp-session-uploading {\n  margin: 0;\n  padding: 0 12px 10px;\n  font-size: 12px;\n  color: var(--dp-muted, #94a3b8);\n  text-align: center;\n}\n\n/* Embedded Digiping toolbar */\n.digiping-chat__embedded-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0.45rem 1rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(8, 15, 28, 0.35);\n  flex-shrink: 0;\n}\n\n/* Voice hold overlay — Digiping-aligned */\n.lt-fb-voice-hold-portal {\n  position: fixed;\n  inset: 0;\n  z-index: 1450;\n  background: rgba(8, 12, 22, 0.72);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding: 16px;\n  padding-bottom: max(16px, env(safe-area-inset-bottom));\n}\n\n.lt-fb-voice-hold {\n  width: min(100%, 420px);\n  background: var(--dp-glass, rgba(15, 23, 42, 0.96));\n  border-radius: 16px;\n  border: 1px solid var(--dp-border, rgba(255, 255, 255, 0.08));\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);\n  overflow: hidden;\n  color: var(--dp-text, #f8fafc);\n}\n\n.lt-fb-voice-hold .fb-conv-header,\n.lt-fb-voice-hold .digiping-chat__header {\n  position: relative;\n  padding-right: 44px;\n}\n\n.lt-fb-voice-hold__hint {\n  margin: 0;\n  padding: 0 14px 12px;\n  font-size: 12px;\n  color: var(--dp-muted, #94a3b8);\n}\n\n.lt-fb-voice-hold__composer {\n  padding: 12px 14px 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  display: flex;\n  justify-content: center;\n}\n\n.lt-fb-voice-hold__composer .audio-recorder {\n  background: transparent !important;\n  box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
